import { useEffect, useState } from "react";
import axios from "axios";
import { API, useAuth } from "../App";
import { Link } from "react-router-dom";
import { MapPin, Sparkles } from "lucide-react";

export default function Community() {
  const [members, setMembers] = useState([]);
  const { user } = useAuth();

  useEffect(() => {
    axios.get(`${API}/community`).then(r => setMembers(r.data));
  }, []);

  return (
    <main className="max-w-7xl mx-auto px-6 md:px-12 py-16" data-testid="community-page">
      <div className="max-w-3xl mb-12">
        <div className="text-xs tracking-[0.3em] uppercase text-tc-secondary mb-3">Siamo in tante e tanti</div>
        <h1 className="font-serif text-5xl md:text-6xl text-tc-primary">La comunità</h1>
        <p className="text-tc-muted mt-4 text-lg">
          Non un elenco. Un tessuto. Persone che camminano, coltivano, cucinano, insegnano e imparano insieme.
          {!user && <> Per farti conoscere, <Link to="/login" className="text-tc-secondary underline">unisciti</Link>.</>}
        </p>
      </div>

      {user && (
        <Link to="/profilo" className="inline-flex items-center gap-2 mb-10 text-sm text-tc-primary underline" data-testid="edit-profile-link">
          <Sparkles className="w-4 h-4" /> Completa il tuo profilo per apparire nella comunità
        </Link>
      )}

      {members.length === 0 ? (
        <div className="py-20 text-center text-tc-muted italic font-serif text-xl">
          Nessuno ancora. Sii la prima radice.
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-testid="community-grid">
          {members.map(m => (
            <article key={m.user_id} className="bg-tc-surface rounded-3xl p-6 border border-tc/50 hover:-translate-y-1 transition-transform" data-testid={`member-${m.user_id}`}>
              <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-tc-accent/30 mb-4 bg-tc-bg">
                {m.picture ? (
                  <img src={m.picture} alt={m.name} className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center font-serif text-2xl text-tc-primary">
                    {m.name?.[0] || "·"}
                  </div>
                )}
              </div>
              <h3 className="font-serif text-xl text-tc-primary">{m.name}</h3>
              {m.location && <div className="flex items-center gap-1 text-xs text-tc-muted mt-1"><MapPin className="w-3 h-3" /> {m.location}</div>}
              {m.bio && <p className="text-sm text-tc-muted mt-3 line-clamp-3">{m.bio}</p>}
              {m.interests?.length > 0 && (
                <div className="flex flex-wrap gap-1 mt-4">
                  {m.interests.slice(0, 3).map(i => (
                    <span key={i} className="text-[10px] uppercase tracking-wider px-2 py-1 rounded-full bg-tc-bg border border-tc/50 text-tc-accent">{i}</span>
                  ))}
                </div>
              )}
            </article>
          ))}
        </div>
      )}
    </main>
  );
}
